import { Controller } from '@hotwired/stimulus';
import QRCodeStyling from 'qr-code-styling';

export default class extends Controller {
  static values = {
    content: String,
    fgColor: { type: String, default: '#000000' },
    size: { type: Number, default: 300 },
  };

  connect() {
    this.qrCode = new QRCodeStyling({
      width: this.sizeValue,
      height: this.sizeValue,
      data: this.contentValue,
      margin: 0,
      imageOptions: { saveAsBlob: true, hideBackgroundDots: true, imageSize: 0.4, margin: 0 },
      dotsOptions: { type: 'rounded', color: this.fgColorValue, roundSize: true },
      backgroundOptions: { round: 0, color: 'transparent' },
      cornersSquareOptions: { type: 'dot' },
      cornersDotOptions: { type: 'dot' },
      qrOptions: { errorCorrectionLevel: 'L' },
    });

    this.qrCode.append(this.element);
  }

  disconnect() {
    if (this.element) this.element.innerHTML = '';
    this.qrCode = null;
  }
}
